import './App.css';
import { Suspense, lazy, useEffect } from 'react';
import { Route, Routes, Outlet, Navigate, useLocation } from 'react-router-dom';
import Footer from './components/common/Footer';
import Nav from './components/common/Nav';
import LazySection from './components/common/LazySection';
import Hero from './components/home/Hero';
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";

const Connect = lazy(() => import('./components/connect/Connect'));
const About = lazy(() => import('./components/about/About'));
const TourPackages = lazy(() => import('./components/tourPackages/TourPackages'));
const PrivacyPolicy = lazy(() => import('./components/policy/PrivacyPolicy'));
const Terms = lazy(() => import('./components/policy/Terms'));

const pageFallback = <div className="min-h-screen bg-white" aria-hidden="true" />;
const sectionFallback = <div className="min-h-[160px]" aria-hidden="true" />;

const Home = () => {
  return (
    <>
      <Hero />
      <LazySection loader={() => import('./components/home/BharatIntro')} fallback={sectionFallback} />
      <LazySection loader={() => import('./components/home/Latest')} fallback={sectionFallback} />
      <LazySection loader={() => import('./components/home/Pkg').then((module) => ({ default: module.Pkg }))} fallback={sectionFallback} />
      <LazySection loader={() => import('./components/home/CityCafe').then((module) => ({ default: module.CityCafe }))} fallback={sectionFallback} />
      <LazySection loader={() => import('./components/common/Numbers')} fallback={sectionFallback} />
      <LazySection loader={() => import('./components/home/Tycoons').then((module) => ({ default: module.Tycoons }))} fallback={sectionFallback} />
      <LazySection loader={() => import('./components/home/WhyChooseUs')} fallback={sectionFallback} />
      <LazySection loader={() => import('./components/common/Testimonials')} fallback={sectionFallback} />
      <LazySection loader={() => import('./components/home/Gallery')} fallback={sectionFallback} />
      <LazySection loader={() => import('./components/home/Resale').then((module) => ({ default: module.Resale }))} fallback={sectionFallback} />
    </>
  );
};

const TaxiServiceCards = lazy(() =>
  import('./components/texiService/TaxiServicePage').then((module) => ({
    default: module.TaxiServiceCards,
  }))
);

const TaxiServicePage = lazy(() =>
  import('./components/texiService/TaxiServicePage').then((module) => ({
    default: module.TaxiServicePage,
  }))
);

const PublicLayout = () => {
  return (
    <>
      <Nav />
      <Outlet />
      <Footer />

      <div className="fixed bottom-5 right-5 flex flex-col items-center gap-3 z-50">
        <a
          href="https://wa.me/9116710874"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition transform hover:scale-110"
          title="Chat on WhatsApp"
        >
          <FaWhatsapp size={24} />
        </a>

        <a
          href="tel:+919116710874"
          className="bg-blue-600 hover:bg-blue-700 text-white p-4 rounded-full shadow-lg transition transform hover:scale-110"
          title="Call Now"
        >
          <FaPhoneAlt size={22} />
        </a>
      </div>
    </>
  );
};

const App = () => {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path: location.pathname,
    });
  }, [location]);

  return (
    <Suspense fallback={pageFallback}>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Connect />} />
          <Route path="/about" element={<About />} />
          <Route path="/packages" element={<TourPackages />} />
          <Route path="/taxi-service" element={<TaxiServiceCards />} />
          <Route path="/taxi-service/:city" element={<TaxiServicePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<Terms />} />
          <Route path="/*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default App;
